import routerOptions0 from "/root/front/node_modules/.pnpm/nuxt@3.16.0_@parcel+watcher@2.5.0_@types+node@22.13.10_db0@0.3.1_eslint@9.22.0_jiti@2.4_f3f969b8d2a7aa608fefdd06bf6de2c4/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}